module.exports = __webpack_public_path__ + "img/games-15.1421c1e9.jpg";